"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Shader {
    constructor(context) {
        this.context = context;
        // The (enabled) elements that use this shader.
        this._elements = new Set();
    }
    static getWebGL() {
        return undefined;
    }
    static getC2d() {
        return undefined;
    }
    addElement(elementCore) {
        this._elements.add(elementCore);
    }
    removeElement(elementCore) {
        this._elements.delete(elementCore);
        if (!this._elements) {
            this.cleanup();
        }
    }
    redraw() {
        this._elements.forEach((elementCore) => {
            elementCore.setHasRenderUpdates(2);
        });
    }
    useDefault() {
        // Should return true if this shader is configured (using it's properties) to not have any effect.
        // This may allow the render engine to avoid unnecessary shader program switches or even texture copies.
        return false;
    }
    addEmpty() {
        // Draws this shader even if there are no quads to be added.
        // This is handy for custom shaders.
        return false;
    }
    cleanup() {
        // Called when no more enabled elements have this shader.
    }
}
exports.Shader = Shader;
//# sourceMappingURL=Shader.js.map